/* @flow */
/* global process */

import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import { AppContainer as ReactHotAppContainer } from 'react-hot-loader'
import i18n from 'atpjs/helpers/i18n'
import { urlParams } from 'atpjs/helpers/url'
import Wizard from 'tve/views/wizard'
import { advisorByEmail } from 'tve/api/atp'
import { setEnv } from 'tve/helpers/env'

const AppContainer = process.env.NODE_ENV === 'development' ? ReactHotAppContainer : Fragment

export const initializeApp = (rootElement, apiHost, dataHandler) => {
  i18n.locale = dataHandler.get('locale')
  setEnv('API_HOST', apiHost)

  const params = urlParams(window.location.search.substr(1))

  if (params.email) {
    const email = decodeURIComponent(params.email)
    advisorByEmail(email).then((advisor) => {
      dataHandler.set('advisor', advisor)
      const branches = advisor.get('branches')
      if (branches.size == 1) {
        dataHandler.set('branch', branches.get(0))
      }
    })
  }

  ReactDOM.render(
    <AppContainer>
      <Wizard data={dataHandler} />
    </AppContainer>,
    rootElement
  )
}
